<section class="cmms-description-container">
	@if (textModeEnabled) {
		<p class="select-label">{{ headerText | translate }}</p>
	}
	<div class="description">
		@if (!textModeEnabled) {
			<ng-container *ngTemplateOutlet="textarea"></ng-container>
		} @else {
			@if (!editDescriptionMode) {
				<div class="description-text-editable">
					<div class="text-hover-container" (click)="editDescription()">
						<p
							#descriptionText
							class="description-text"
							[class.expanded]="showMore"
							[class.no-data]="!formControl.value"
							[innerText]="formControl.value || ('add_description' | translate)"
						></p>
					</div>
					@if (isVerticalOverflow) {
						<a class="link-button" (click)="toggleShowMore()">
							{{ (showMore ? 'show_less' : 'show_more') | translate }}
						</a>
					}
				</div>
			} @else {
				<mat-form-field>
					<div class="textarea-wrapper">
						<textarea
							#descriptionArea
							class="resize nice-scroll visible-scroll colored-scroll-track"
							cdkAutosizeMaxRows="12"
							cdkAutosizeMinRows="1"
							cdkTextareaAutosize
							[formControl]="formControl"
							matInput
							[placeholder]="!textModeEnabled ? (headerText | translate) : ''"
							(focusout)="textareaFocusOutHandler($event.target.value)"
						></textarea>
					</div>
					<mat-error>
						@if (formControl.errors?.required) {
							<span>{{ 'required' | translate }}</span>
						}
						@if (formControl.errors?.whitespace) {
							<span>{{ 'spaces_only_is_restricted' | translate }}</span>
						}
					</mat-error>
				</mat-form-field>
			}
		}
	</div>
</section>

<ng-template #textarea>
	<mat-form-field>
		<div class="textarea-wrapper">
			<textarea
				#descriptionArea
				class="resize nice-scroll visible-scroll colored-scroll-track"
				cdkAutosizeMaxRows="12"
				cdkAutosizeMinRows="1"
				cdkTextareaAutosize
				[formControl]="formControl"
				matInput
				[placeholder]="!textModeEnabled ? (headerText | translate) : ''"
				(focusout)="textareaFocusOutHandler($event.target.value)"
			></textarea>
		</div>

		<mat-error>
			@if (formControl.errors?.required) {
				<span>{{ 'required' | translate }}</span>
			}
			@if (formControl.errors?.whitespace) {
				<span>{{ 'spaces_only_is_restricted' | translate }}</span>
			}
		</mat-error>
	</mat-form-field>
</ng-template>
